module.exports = __webpack_public_path__ + "img/info.47197c1b.svg";